import React from "react";

export const FinalStep = ({subdomain, currentDomain}) => {
    return <div className={"step flexRowContainer flexAlignCenter"} id={"fireworks"}>
        <span className={'fa fa-check-circle fa-5x completedSetup'}/><br/>
        <h3 className={"mb10"}>That was easy (hopefully)</h3>
        You have successfully set up qube and are now ready to enter your new office!<br/>
        Here is your very own workspace link:<br/>
        <b><a href={'https://' + subdomain + '.' + currentDomain}
              target={'_blank'} rel="noreferrer">{'https://' + subdomain + '.' + currentDomain} </a></b>

        Share this link with your co-workers so they can join you in your brand-new virtual office
        space.
    </div>
}